import * as React from "react";
import {FileResource} from "~/client/resources/fileResource";
import {FriendlyLocalTime} from "shared/FriendlyLocalTime";
import {bytesToMegaBytes} from "areas/storageConversions";
import {DownloadFileDialog} from "areas/files/DownloadFileDialog";
import {OverflowMenu} from "components/Menu";
import {DoBusyTask} from "components/DataBaseComponent/DataBaseComponent";
import BaseComponent from "components/BaseComponent";
import { Callout } from "@octopusdeploy/design-system-components";
import SimpleDataTable from "components/SimpleDataTable";
import repository from "client/repository";

class DataTable extends SimpleDataTable<FileResource> {
}

interface Props {
    instanceId: string;
    files: FileResource[];
    doBusyTask: DoBusyTask;
    onFilesChanged?: () => void
}

export class DiagnosticFilesTable extends BaseComponent<Props, never> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return <>
            <Callout type="warning" title={"Warning"}>
                Please delete Diagnostic Files once downloaded. Note: All Diagnostic Files will be automatically deleted after 7 days.
            </Callout>
            <DataTable
                data={this.props.files}
                onRow={this.buildRow}
                onRowOverflowMenu={(file: FileResource) => this.getOverflowMenu(file)}
                headerColumns={["Name", "Last Modified", "Size In MB"]}
                onEmpty={<div>No files found</div>}
            />
        </>;
    }

    private buildRow = (file: FileResource) => {
        return [
            file.Name,
            <FriendlyLocalTime time={file.LastModified}/>,
            bytesToMegaBytes(file.SizeInBytes)
        ];
    }

    private getDownloadLink = (file: FileResource)=> {
        return <DownloadFileDialog
            title={"Download Diagnostic File"}
            getDownloadUrl={(justification) => repository.HostedInstances.getUrlToDiagnosticFileContent(this.props.instanceId, file, justification)}
        />
    }

    private getOverflowMenu = (file: FileResource) => {
        return [
            OverflowMenu.dialogItem("Download", this.getDownloadLink(file)),
            OverflowMenu.deleteItem(
                "Delete",
                "Are you sure you want to delete this diagnostic file?",
                () => this.deleteDiagnosticFile(file),
                <>
                    <p>Do you wish to continue?</p>
                </>)
        ];
    }

    private deleteDiagnosticFile = (file: FileResource)=> {
        return this.props.doBusyTask(async () => {
            await repository.HostedInstances.deleteDiagnosticFile(this.props.instanceId, file);
            if (this.props.onFilesChanged) {
                this.props.onFilesChanged();
            }
        });
    }
}

export default DiagnosticFilesTable;
